import React, { useState } from "react";
import apiClient from "../../../../../api/apiClient";
import useLicenseSearch from "../../../../../components/SupplyChainPartners/useLicenseSearch";
import { PROFILE_TO_PARTNER_TYPE, partnerTypeLabel } from "../../../../../constants/supplyChain";
import { leadDisplayName } from "../shared/crmConstants";

/**
 * "This lead is now this DYC license": search DYC licenses and link. The lead becomes won and
 * every business that reported it now lists the license (they and the license are notified).
 */
const LinkLicenseModal = ({ lead, onClose, onLinked }) => {
    const search = useLicenseSearch({ mode: "auth" });
    const [picked, setPicked] = useState(null);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    const submit = async () => {
        if (!picked) return;
        setSaving(true);
        setError("");
        try {
            await apiClient.post(`/admin/crm/leads/${lead.id}/link-license`, { licenseId: picked.id });
            onLinked();
        } catch (err) {
            setError(err.response?.data?.error || "Failed to link license");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="crm-modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
            <div className="crm-modal" style={{ maxWidth: 520 }} role="dialog" aria-modal="true" aria-labelledby="link-license-title">
                <div className="crm-modal__header">
                    <h2 id="link-license-title" className="crm-modal__title">Link {leadDisplayName(lead)} to a DYC license</h2>
                    <button className="crm-modal__close" onClick={onClose} type="button" aria-label="Close">×</button>
                </div>
                <div className="crm-modal__body">
                    {error && <div className="lf-error">{error}</div>}
                    <label htmlFor="link-license-search" className="admin-form-label">Search DYC licenses</label>
                    <input
                        id="link-license-search"
                        className="admin-input"
                        autoFocus
                        placeholder="Business name (3+ characters)"
                        value={search.query}
                        onChange={(e) => {
                            setPicked(null);
                            search.search(e.target.value);
                        }}
                    />
                    <p className="admin-license-meta" aria-live="polite">
                        {search.status === "searching" && "Searching…"}
                        {search.status === "done" && search.results.length === 0 && "No licenses match."}
                    </p>
                    <div role="radiogroup" aria-label="Licenses">
                        {search.results.map((r) => (
                            <label key={r.id} className="admin-license-user-chip" style={{ display: "flex", gap: 8, cursor: "pointer" }}>
                                <input type="radio" name="link-license" checked={picked?.id === r.id} onChange={() => setPicked(r)} />
                                <span>
                                    <strong>{r.company}</strong>{" "}
                                    <span className="admin-license-meta" style={{ display: "inline" }}>
                                        {[partnerTypeLabel(PROFILE_TO_PARTNER_TYPE[r.profile]), [r.city, r.state].filter(Boolean).join(", ")].filter(Boolean).join(" · ")}
                                    </span>
                                </span>
                            </label>
                        ))}
                    </div>
                </div>
                <div className="crm-modal__footer">
                    <button className="admin-btn" onClick={onClose} disabled={saving} type="button">Cancel</button>
                    <button className="admin-btn admin-btn--primary" onClick={submit} disabled={!picked || saving} type="button">
                        {saving ? "Linking…" : "Link license"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LinkLicenseModal;
